<div [ngClass]="['steps', style, direction]">
  <ng-template ngFor let-step [ngForOf]="list" let-j="index">
    <div
      class="steps-item step--{{ list.length || 1 }}"
      [class.steps-item--active]="step.active"
      [class.step-negative]="step.level === 'error'"
      *ngIf="!step.hidden"
    >
      <span class="checkmark" *ngIf="step.level === 'step' || !step.level"></span>
      <span class="checkmark negative" *ngIf="step.level === 'error'"></span>
      <div class="steps-items-labels">
        <label class="steps-item-title">{{ step.title }}</label>
        <small class="steps-item-description" *ngIf="showDescription">{{ step.description }}</small>
      </div>
    </div>
  </ng-template>
</div>
